import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEVICE_TYPES, TYPE_META } from './stateMeta';
import { EQUIPMENT_TYPE_HINT_KEY } from '../../lib/fleetHeaderStats';
import { EquipmentHealthValue } from '../../lib/EquipmentHealthValue';
import { accentAt, Eyebrow, StatTile } from '../ui/surface';

const FilterTile = ({ active, onClick, ...tile }) => (
  <StatTile
    as="button"
    size="sm"
    active={active}
    quietCap={!active}
    accentOnHover
    aria-pressed={active}
    onClick={onClick}
    {...tile}
  />
);

/**
 * Сводка парка: клик по плашке задаёт фильтр списка.
 * «Школ оснащено» сбрасывает фильтры; виды — type; «без оборудования» — not equipped.
 */
const FleetSummary = ({
  overview,
  activeType = '',
  showNotEquipped = false,
  filtersCleared = true,
  onResetFilters,
  onFilterType,
  onShowNotEquipped,
}) => {
  const { t } = useTranslation();
  const coverage = overview?.coverage || {};
  const byType = overview?.byType || {};

  return (
    <section>
      <Eyebrow>{t('equipment.summary.coverageTitle')}</Eyebrow>
      <div className="mt-3 grid grid-cols-2 gap-3 lg:grid-cols-3">
        <FilterTile
          eyebrow={t('equipment.summary.schoolsEquipped')}
          icon="school"
          value={`${coverage.schoolsEquipped ?? 0} / ${coverage.schoolsTotal ?? 0}`}
          onClick={onResetFilters}
          active={filtersCleared}
          {...accentAt(0)}
        />
        {DEVICE_TYPES.map((type, index) => (
          <FilterTile
            key={type}
            eyebrow={t(`equipment.types.${type}`)}
            icon={TYPE_META[type].icon}
            value={<EquipmentHealthValue typeSummary={byType[type]} type={type} className="" />}
            sublabel={t(EQUIPMENT_TYPE_HINT_KEY[type])}
            onClick={() => onFilterType(type)}
            active={!showNotEquipped && activeType === type}
            {...accentAt(index + 1)}
          />
        ))}
        <FilterTile
          eyebrow={t('equipment.summary.schoolsNotEquipped')}
          icon="block"
          value={coverage.schoolsNotEquipped ?? 0}
          sublabel={t('equipment.summary.showThem')}
          onClick={onShowNotEquipped}
          active={showNotEquipped}
          {...accentAt(DEVICE_TYPES.length + 1)}
        />
      </div>
      <p className="mt-3 text-[11px] leading-relaxed text-muted-500">
        <span className="material-icons align-[-3px] text-sm">info</span>{' '}
        {t('equipment.summary.coverageNote')}
      </p>
    </section>
  );
};

export default FleetSummary;
